<template>
  <div
    class="auth-box-wrapper d-flex flex-column align-items-center justify-content-center"
  >
    <eg-b-alert
      class="alert"
      :show="!!error"
      variant="danger"
      dismissible
      data-testid="error-alert"
    >
      <div data-testid="error-alert-message">
        {{ error }}
      </div>
    </eg-b-alert>

    <eg-b-alert
      v-if="successData"
      variant="success"
      show
      dismissible
      data-testid="success-alert"
    >
      <strong class="alert-success" data-testid="success-alert-title">
        {{ successData.title }}
      </strong>
      <div data-testid="success-alert-message">
        {{ successData.message }}
      </div>
    </eg-b-alert>

    <div class="auth-box" data-testid="auth-box">
      <div class="d-flex align-items-center justify-content-center flex-column">
        <img
          class="logo"
          src="../../assets/auth-logo.png"
          alt="EssayGrader Logo"
          data-testid="auth-box-logo"
        />

        <h1 v-if="title" class="title my-4 py-2" data-testid="auth-box-title">
          {{ title }}
        </h1>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    error: {
      type: String,
      default: "",
    },
    successData: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style scoped lang="scss">
.auth-box-wrapper {
  height: calc(100vh - 48px);
}

.alert,
.auth-box {
  max-width: 547px;
  width: 100%;
}

.auth-box {
  padding: 30px 0;
  border-radius: 12px;
  border: 1px solid #e9ecef;
  background-color: #fff;

  .logo {
    width: 162px;
  }

  .title {
    font-family: "Roboto", "Rubik", sans-serif;
    font-size: 40px;
    font-weight: 500;
    line-height: 48px;
    text-align: center;
    margin: 30px 0;
  }
}
</style>
